// src/api/services/farm/farmService.js
import client from '../client';

const BASE = '/api/features';

/** Get all features */
export function getFeatures(includeInactive = false) {
  const params = includeInactive ? { includeInactive } : {};
  return client.get(BASE, { params }).then(res => res.data);
}

/** Get feature count */
export function getFeatureCount() {
  return client.get(`${BASE}/count`).then(res => res.data);
}

/** Create feature */
export function createFeature(payload) {
  return client.post(BASE, payload).then(res => res.data);
}

/** Update feature */
export function getFeatureById(id) {
  return client.get(`${BASE}/${id}`).then(res => res.data);
}

/** Update feature */
export function updateFeature(id, payload) {
  return client.put(`${BASE}/${id}`, payload).then(res => res.data);
}

/** Delete feature */
export function deleteFeature(id) {
    return client.delete(`${BASE}/${id}`).then(res => res.data);
}
